import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import { RootState } from '@/store';
import Shepherd from 'shepherd.js';

Vue.use(Vuex);
export interface TourState {
  tour: Shepherd.Tour | null;
}
export const tour: Module<TourState, RootState> = {
  state: () => {
    return {
      tour: null,
    };
  },
  getters: {
    policiesTour(state: TourState): Shepherd.Tour | null {
      return state.tour;
    },
  },
  actions: {
    setPoliciesTour(ctx, tour: Shepherd.Tour) {
      ctx.commit('setPoliciesTour', tour);
    },
    cancelTour(ctx) {
      ctx.commit('cancelTour');
    },
  },
  mutations: {
    setPoliciesTour(state: TourState, tour) {
      state.tour = tour;
    },
    cancelTour(state: TourState) {
      state.tour = null;
    },
  },
};
